<template>
  <div id="liveHqD">
    <topNav typeName vuePage="#liveHqD" title="带货获取详情" back="1"></topNav>
    <!--顶部-->
    <div class="item">
      <img :src="good_info.good_thumb" class="imgBlock noevents-img" />
      <p>{{good_info.goods_name}}</p>
    </div>
    <!--信息-->
    <ul>
      <li class="flex-box">
        <span class="s1">数量(件)</span>
        <span class="s2 bold">{{good_info.nums}}</span>
      </li>
      <li class="flex-box">
        <span class="s1">代言获取珍珠(个)</span>
        <span class="s2 bold">{{good_info.money}}</span>
      </li>
      <li class="flex-box">
        <span class="s1">时间</span>
        <span class="s2">{{good_info.create_time | timestamp}}</span>
      </li>
      <li class="flex-box">
        <span class="s1">订单状态</span>
        <span class="s2 bold" v-if="good_info.pay_status == 1">未支付</span>
        <span class="s2 bold" v-if="good_info.pay_status == 2">已支付</span>
        <span class="s2 bold" v-if="good_info.pay_status == 3">退款/售后中</span>
      </li>
      <li class="flex-box">
        <span class="s1">结算状态</span>
        <span class="bold red flex-box" v-if="good_info.show_status == 1">
          <countdown :time="good_info.create_time*1+864000" :showbox="showbox" @countdownClose="hiddenbox" v-if="showbox"></countdown>
          后结算
        </span>
        <span class="bold ready" v-if="good_info.show_status == 2">已结算</span>
        <span class="bold tui" v-if="good_info.show_status == 3">已退款</span>
      </li>
    </ul>
  </div>
</template>










<script>
import topNav from "../index/top_nav";
import countdown from "@/components/shop/countdown00";

export default {
  name: "liveHqD",
  components: {
    topNav,
    countdown,
  },
  data() {
    return {
      good_info: {},
      showbox: true
    };
  },
  methods: {
    hiddenbox() {
      this.showbox = false
    },
    // 获取详情
    getDetail() {
      this.good_info = JSON.parse(localStorage.getItem("goodHq"));
    },
  },
  mounted: function () {
    this.$tool.setTitle("带货获取详情");
    this.getDetail();
  },
};
</script>









<style scoped>
/**顶部 */
.item {
  padding: 28px 16px;
}
.item img {
  width: 55px;
  margin: 0 auto;
  border-radius: 8px;
}
.item p {
  margin-top: 4px;
  font-size: 16px;
  text-align: center;
  color: #333;
}

/**信息 */
li {
  justify-content: space-between;
  padding: 15px 16px;
  font-size: 14px;
  background: white;
}
.bold {
  font-weight: bold;
}
ul li .red {
  color: #ff6161;
}
li .s1 {
  color: #333;
}
li .s2 {
  font-size: 14px;
  color: #333;
}
.ready {
  color: #0e9eb5;
}
.tui {
  color: #999999;
}
</style>
